import EFOcats_making from '../../../core/v2/making/efocats_making.js';
import EFOcats_import_html from '../../../core/v2/import/efocats_import_html.js';
import EFOcats_import_lang from '../../../core/v2/import/efocats_import_lang.js';
import EFOcats_curves_answer_select from '../answer/efocats_curves_answer_select.js';

export default class EFOcats_curves_making extends EFOcats_making {
  constructor() {
    super();
    this.titleExcludes = ['?', '？', '!', '！', '。', 'ください', '下さい'];

    this.answersettings.select = new EFOcats_curves_answer_select();
  }

  /**
   * フレームに対するスタイルを設定、設置する
   */
  style() {
    super.style();
    require('../scss/efocats.scss');
  }

  /**
   * ページの拡張
   * @param label_tmp
   * @param elem
   * @param number
   */
  page_extend(label_tmp, elem, number) {
    super.page_extend(label_tmp, elem, number);

    const inputs = elem.find('input,textarea,select');
    for (let index = 0; index < inputs.length; index++) {
      const input = inputs.eq(index);
      const name = input.attr('name');
      const type = input.attr('type');

      // タイトル
      if (efocats.titleList[name] && elem.find('.cat-title').length === 0) {
        elem.find('.container').prepend(EFOcats_import_html.getValue('cat-title'));
        elem.find('.cat-title').text(efocats.titleList[name]);
      }

      // 説明
      if (efocats.infoList[name]) {
        if ((type === 'radio' || type === 'checkbox') && elem.find(`[name="${name}"]`).index(input) === 0) {
          elem.find('.cat-txt').first().before(EFOcats_import_html.getValue('cat-info'));

          if (Array.isArray(efocats.infoList[name])) {
            for (let ind = 0; ind < efocats.infoList[name].length; ind++) {
              const info = efocats.infoList[name][ind];
              elem.find('.cat-info').append(`<li>${info}</li>`);
            }
          } else {
            const info = efocats.infoList[name];
            elem.find('.cat-info').append(`<li>${info}</li>`);
          }
        } else {
          elem.find('.cat-txt').first().before(EFOcats_import_html.getValue('cat-info'));

          if (Array.isArray(efocats.infoList[name])) {
            for (let ind = 0; ind < efocats.infoList[name].length; ind++) {
              const info = efocats.infoList[name][ind];
              elem.find('.cat-info').append(`<li>${info}</li>`);
            }
          } else {
            const info = efocats.infoList[name];
            elem.find('.cat-info').append(`<li>${info}</li>`);
          }
        }
      }

      // 注意書き
      if (efocats.attentionList[name]) {
        if ((type === 'radio' || type === 'checkbox') && elem.find(`[name="${name}"]`).index(input) === 0) {
          if (elem.find('.container .cat-attention').length === 0) {
            elem.find('.container').append(EFOcats_import_html.getValue('cat-attention'));
          }

          if (Array.isArray(efocats.attentionList[name])) {
            for (let ind = 0; ind < efocats.attentionList[name].length; ind++) {
              const info = efocats.attentionList[name][ind];
              elem.find('.cat-attention').append(`<li>${info}</li>`);
            }
          } else {
            const info = efocats.attentionList[name];
            elem.find('.cat-attention').append(`<li>${info}</li>`);
          }
        } else {
          if (elem.find('.container .cat-attention').length === 0) {
            elem.find('.container').append(EFOcats_import_html.getValue('cat-attention'));
          }

          if (Array.isArray(efocats.attentionList[name])) {
            for (let ind = 0; ind < efocats.attentionList[name].length; ind++) {
              const info = efocats.attentionList[name][ind];
              elem.find('.cat-attention').append(`<li>${info}</li>`);
            }
          } else {
            const info = efocats.attentionList[name];
            elem.find('.cat-attention').append(`<li>${info}</li>`);
          }
        }
      }

      // 中設問
      if (efocats.labelList[name] !== undefined) {
        elem.find(`.cat-txt[target-name="${name}"]`).text(efocats.labelList[name]);
      }

      // アコーディオン
      if (efocats.proj.env.accordionList[name]) {
        input
          .parents('.inner')
          .after(EFOcats_import_html.getValue('accordion', {title: efocats.proj.env.accordionList[name].title, content: efocats.proj.env.accordionList[name].content}));
      }

      // プライバシールール
      if (name === 'email') {
        elem.find('.inner').after(EFOcats_import_html.getValue('privacy'));
      } else if (name === 'tel_time_0') {
        elem.find('.inner').removeClass('singleboxs').addClass('doubleboxs');
      }
    }

    // Envに定義がない時の大設問設定
    this.defaultTitle(label_tmp, elem, number);
  }

  /**
   * Envに定義がない時の大設問設定
   * @param {*} label_tmp
   * @param {*} elem
   * @param {*} number
   */
  defaultTitle(label_tmp, elem, number) {
    if (elem.find('.cat-title').length === 0) {
      // タイトルエリア追加
      elem.find('.container').prepend(EFOcats_import_html.getValue('cat-title'));

      // 除外文字列判定
      let excludeFlag = false;
      for (let index = 0; index < this.titleExcludes.length; index++) {
        const exclude = this.titleExcludes[index];
        if (label_tmp.question.indexOf(exclude) >= 0) {
          excludeFlag = true;
          break;
        }
      }

      const type = elem.find('input,select,textarea').first().attr('type');
      const tag = elem.find('input,select,textarea').first().prop('tagName').toLowerCase();

      if (excludeFlag) {
        // 除外文字列を含んでいる時はそのまま出力
        elem.find('.cat-title').text(`${label_tmp.question}`);
      } else if (type === 'checkbox' || type === 'radio' || tag === 'select') {
        // 選択方式の場合
        elem.find('.cat-title').text(`${label_tmp.question}${EFOcats_import_lang.getValue('defaultTitle_select')}`);
      } else {
        // 入力方式の場合
        elem.find('.cat-title').text(`${label_tmp.question}${EFOcats_import_lang.getValue('defaultTitle_input')}`);
      }
    }
  }

  /**
   * go-flg付与、送信ボタン設置などの仕上げ処理
   */
  form_extend() {
    super.form_extend();
    this.$('.cat-wrapper').prepend(EFOcats_import_html.getValue('cat-header'));

    // ご来店希望日時のOKを外す
    this.$('[name="entry1_time"]').parents('.qa').find('.ok-flag').removeClass('ok-flag');

    // 「簡単1分！ご来店のお申し込み」
    this.$('.cat-section--border').prepend(EFOcats_import_html.getValue('page_header'));

    // 複数選択マーク
    this.$('.cat-txt[target-name="tel_time_empty"]').addClass('icon-multi');
  }

  /**
   * 回答欄設置クラスの使用条件設定
   */
  set_answers(tmp, answer, elem) {
    super.set_answers(tmp, answer, elem);

    // 任意
    if (!answer['data-required'] || answer['data-required'] !== '1') {
      this.answers.push('nini');
    }
  }
}
